module.exports = __webpack_public_path__ + "static/media/LosMonstruos.4669ef10.jpg";